import _ from 'underscore';

export function updateGridQuery(gridView, filter, refresh = true, skipFilterOptions = false) {
  const currentQuery = gridView.get('query');
  let newQuery = null;

  if (filter && filter.query && !_.isEmpty(filter.query)) {
    newQuery = _.defaults({
      filter: filter.query,
      options: _.defaults({
        filterOptions: skipFilterOptions ? undefined : _.extend(filter.odataOptions, _.pick(filter, 'schema')),
      }, currentQuery.options),
    }, currentQuery);
  } else {
    newQuery = _.omit(currentQuery, 'filter');
  }

  gridView.set({
    query: newQuery,
  });

  if (refresh) {
    gridView.refresh(true);
  }
}
